<script setup>
defineProps({
  date: {
    type: String,
    default: undefined,
  },

  time: {
    type: String,
    default: undefined,
  },
  timeType: {
    type: String,
    default: undefined,
  },

  addText: {
    type: String,
    default: undefined,
  },
  placeholder: {
    type: String,
    default: undefined,
  },
  iconName: {
    type: String,
    default: 'calendar',
  },

  isDateSelected: {
    type: Boolean,
    default: true,
  },
  isRemovable: {
    type: Boolean,
    default: false,
  },

  isDropdownVisible: {
    type: Boolean,
    default: false,
  },

  roundedLeft: {
    type: Boolean,
    default: false,
  },
  roundedRight: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['add', 'remove']);
</script>

<template>
  <div
    class="ui-selected-date-time"
    :class="{ 'ui-selected-date-time--focused': isDropdownVisible }"
  >
    <div
      class="ui-selected-date-time__container"
      :class="{
        'ui-selected-date-time__container--rounded-left': roundedLeft,
        'ui-selected-date-time__container--rounded-right': roundedRight,
      }"
      @click="emit('add')"
    >
      <CIcon
        class="ui-selected-date-time__icon"
        :class="`ui-selected-date-time__icon--${iconName}`"
        :name="iconName"
      />

      <div class="ui-selected-date-time__content">
        <span v-if="date" class="ui-selected-date-time__font">
          {{ date }}
        </span>
        <span
          v-else-if="placeholder"
          class="ui-selected-date-time__font ui-selected-date-time__font--placeholder"
        >
          {{ placeholder }}
        </span>

        <!--        <UiTime v-if="time" theme="black" :text="timeType" :time="time" />-->
      </div>

      <button
        v-if="isDateSelected && isRemovable"
        type="button"
        class="ui-selected-date-time__button ui-selected-date-time__button--remove"
        aria-label="Remove date"
        @click.stop="emit('remove')"
      >
        <CIcon
          class="ui-selected-date-time__icon ui-selected-date-time__icon--cross"
          name="cross"
        />
      </button>
    </div>
  </div>
</template>
